<div style=" margin-top: 6.5%;display: flex;width: 100%;">
    <app-jsip-left-pannel (sidenavToggle)="isSidenavOpen = $event" class="jsip_Lpannel" [class.collapsed]="!isSidenavOpen"></app-jsip-left-pannel>
<div class="topDiv_with_LPannel" [class.collapsed]="!isSidenavOpen">
  <app-jsip-product-info-bar></app-jsip-product-info-bar>

<div *ngIf="!showWorkflow" class="main-container"
    [class.workflow-mode]="showWorkflow"
     [class.default-mode]="!showWorkflow">

<div *ngIf="!showWorkflow" class="label-bar">

  <label
    i18n="@@spmsUserReg"
    class="textColour header-label-text">
   Review Activities
  </label>
  <button mat-icon-button 
              class="header-config-btn"
              (click)="$event.stopPropagation(); openColumnsDialog()"
              matTooltip="Select columns to display">
             <mat-icon>tune</mat-icon>
      </button>
       <button mat-icon-button 
              class="header-config-btn"
              (click)="$event.stopPropagation(); openCalendarDialog()"
              matTooltip="Click to open calendar" >
             <mat-icon>calendar_today</mat-icon>
      </button>
      <!-- <div class="summary-card calendar-card" (click)="openCalendarDialog()">
    <div class="value">
      <mat-icon style="font-size: 20px;
    color: grey;">calendar_today</mat-icon>
      
    </div>
</div> -->
   <span class="example-spacer"></span>
     
       <app-common-button
            
          title="Refresh"
          icon="fas fa-sync-alt"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onrefresh()"
          style="margin-right:1%"
          >
      </app-common-button>
        <app-common-button
            title="Download"
          icon="fas fa-download"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onDownloadhistory()"
          style="margin-right:1%"
          >
      </app-common-button>
      <app-common-button
 
          label="Ad-Hoc Activity"
          title="Ad-Hoc Activity "
          icon="fas fa-plus-circle"
          [buttonId]="143"
          height="25px"
          width="130px"
          [critical]="true"
          (clicked)="openAddhocActivityPopUp()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>


</div>
  <!-- statistics-dashboard -->
<div class="summary-row">
  <div class="summary-card"
       (click)="onCardClick('New')"
       [class.active]="activeFilter === 'New'">
    <div class="label">New Activities</div>
        <div class="value">{{ newCount }}</div>

  </div>

  <div class="summary-card" 
       (click)="onCardClick('In Review')"
       [class.active]="activeFilter === 'In Review'">
    <div class="label">In Review</div>
        <div class="value">{{ inReviewCount }}</div>

  </div>

  <div class="summary-card"
       (click)="onCardClick('Completed')"
       [class.active]="activeFilter === 'Completed'">
    <div class="label">Completed</div>
        <div class="value">{{ completedCount }}</div>

  </div>

  <div class="summary-card"
       (click)="onCardClick('Overdue')"
       [class.active]="activeFilter === 'Overdue'">
    <div class="label">Overdue</div>
        <div class="value">{{ overdueCount }}</div>

  </div>
    <div class="summary-card"
       (click)="onCardClick('signaldetected')"
       [class.active]="activeFilter === 'signaldetected'">
    <div class="label">Signal Identified</div>
        <div class="value">{{ signalDetectedCount }}</div>

  </div>
</div>



  <!--Dataset Dropdown -->
  <!-- <div style="font-family: Arial; margin: 1rem;">
  <label for="datasetSelect" style="font-weight: bold;">Select Dataset:</label>

  <select
    id="datasetSelect"
    class="form-select"
    [(ngModel)]="selectedDataset"
    (change)="onDatasetSelect()"
    style="margin-left: 8px; padding: 4px; border-radius: 4px;"
  >
    <option value="">-- Select Dataset --</option>
    <option *ngFor="let ds of datasets" [ngValue]="ds">
      {{ ds.datasetname }}
    </option>
  </select>

  Dataset Details
  <div *ngIf="selectedDataset" style="margin-top: 1rem; font-size: 14px;">
    <div><strong>Dataset Name:</strong> {{ selectedDataset.datasetname }}</div>
    <div><strong>Description:</strong> {{ selectedDataset.description }}</div>
    <div><strong>Type:</strong> {{ selectedDataset.datasetType }}</div>
    <div><strong>Status:</strong> {{ selectedDataset.status }}</div>
    <div *ngIf="selectedDataset.dataset_rolesIdStrings">
      <strong>Associated Roles:</strong>
      {{ selectedDataset.dataset_rolesIdStrings }}
    </div>
  </div>
</div> -->

  <!-- Fallback for no data or error -->
  <ng-template #noData>
    <div class="stats no-data-container">
      <div class="stat-card no-data">
        <div class="label">
          {{ errorMessage || "Data unavailable at the moment." }}
        </div>
                <div class="value">⚠️</div>

      </div>
    </div>
  </ng-template>

  <!-- Ag-Grid -->

 
    <!-- Grid Wrapper -->
<div class="grid-wrapper">
    <div
      [style.background-color]="backgroundColorScreen"
      style="
        margin: 0 15px 0 15px;
        border-radius: 0.8vh;
      "
    >
      <!-- Toolbar -->
      <!-- <mat-toolbar
        class="agGridtoperDiv card"
        style="
          background: rgb(244 243 245);
          margin-top: 0;
          border-top: 1px solid #a9a9a9a8;
          border-right: 1px solid #a9a9a9a8;
          border-left: 1px solid #a9a9a9a8;"
        
      > 
      <button mat-icon-button 
              class="header-config-btn"
              (click)="$event.stopPropagation(); openColumnsDialog()"
              matTooltip="Select columns to display">
             <mat-icon>tune</mat-icon>
      </button>
      <div class="summary-card calendar-card" style="margin-top: 1%;" (click)="openCalendarDialog()">
    <div class="value">
      <mat-icon>calendar_today</mat-icon>
      
    </div>
</div>
        <span class="example-spacer"></span>
 

        <app-common-button
 
          label="Ad-Hoc Activity"
 
          title="Ad-Hoc Activity "
 
          icon="fas fa-plus-circle"
 
          [buttonId]="143"
 
          width="130px"
          [critical]="true"
          (clicked)="openAddhocActivityPopUp()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
 

        <app-common-button
 
          label="Download"
 
          title="Download "
 
          icon="fas fa-download"
 
          [buttonId]="1111"
 
          [critical]="false"
          (clicked)="onDownloadhistory()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
 
        <app-common-button
 
          label="Refresh"
 
          title="Refresh "
 
          icon="fas fa-sync-alt"
 
          [buttonId]="1111"
 
         
          [critical]="false"
          (clicked)="onrefresh()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
 
        <div class="insertPageNoDiv">
          <mat-form-field appearance="outline">
            <mat-label>Page No</mat-label>
            <input
              matInput
              type="text"
              (input)="onRunSearchChange($event.target.value)"
            />
          </mat-form-field>
        </div>
 
        <div class="selectRecordsDiv" style="width: 9.5%">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Records</mat-label>
            <mat-select
              ngDefaultControl
              [(ngModel)]="RunpageSize"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onRunPageSizeChanged(value)"
            >
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
 
        <div
          class="card pagination paginationFirstButton paginationFirstlastButton"
        >
          <em
            class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onRunBtFirst()"
          ></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
          <ul>
            <li class="paginationliicon">
              <em
                class="fas fa-angle-left waves-effect waves-light"
                (click)="onRunBtPrevious()"
              ></em>
            </li>
            <li>{{ RuncurrentPage }}/{{ RuntotalPages }}</li>
            <li class="paginationliicon" style="padding: 0">
              <em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onRunBtNext()"
              ></em>
            </li>
          </ul>
        </div>
        <div
          class="card pagination paginationLastButton paginationFirstlastButton"
        >
          <em
            class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onRunBtLast()"
          ></em>
        </div>
      </mat-toolbar> -->

      <!-- AG Grid -->
      <ag-grid-angular
        style="height: 50vh"
        id="Grid"
        class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefs"
        [rowMultiSelectWithClick]="true"
        [animateRows]="true"
        [pagination]="true"
        [rowData]="gridRowData"
        [defaultColDef]="defaultColDef"
        [suppressPaginationPanel]="true"
        [rowHeight]="35"
        [headerHeight]="35"
        [enableBrowserTooltips]="true"
        [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize"
        [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true"
        [components]="components"
        [debug]="true"
        (paginationChanged)="onPaginationChanged()"
        (gridReady)="onGridReady($event)"
        [rowClassRules]="rowClassRules"
        [getRowStyle]="getRowStyle"
      >
      </ag-grid-angular>
       <div class="custom-pagination">
  <span class="range-text">
    {{ startRow }} to {{ endRow }} of {{ totalRows }}
  </span>

  <!-- <button (click)="goToFirst()" [disabled]="currentPage === 1">
     
  </button> -->
  <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onRunBtFirst()"></em>
  <em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="onRunBtPrevious()"></em>
  <!-- <button (click)="goToPrevious()" [disabled]="currentPage === 1">‹</button> -->

  <span class="page-text">
    Page {{ RuncurrentPage }} of {{ RuntotalPages }}
  </span>
<em class="fas fa-angle-right waves-effect waves-light" (click)="onRunBtNext()"></em>
<em class="fas fa-angle-double-right waves-effect waves-light" (click)="onRunBtLast()"></em>
  <!-- <button (click)="goToNext()" [disabled]="currentPage === totalPages">›</button>
  <button (click)="goToLast()" [disabled]="currentPage === totalPages">»</button> -->
</div>
    </div>
    </div>
 
</div>


<!-- Review Work Flow Screen  -->
<div *ngIf="showWorkflow" class="main-container"
    [class.workflow-mode]="showWorkflow"
     [class.default-mode]="!showWorkflow">
  <app-review-workflow 
  (back)="onBackFromWorkflow()"
  [activity]="selectedActivity"
  [instancedetailid]="instancedetailid"
  [reportTemplateId]="selectedActivityReportTemplate"
  > 
  </app-review-workflow>
</div>

</div>
</div>